module.exports = __webpack_public_path__ + "static/0005-9090a8c6ec56376b94a7474626e46750.jpg";